import { v4 as uuid } from 'uuid';
import Trans from 'next-translate/Trans';
import { Lot } from 'types';
import { updateNewUUIDs } from './updateNewUUIDs';
import { addDefaultsToLineItem } from './addDefaultsToLineItem';

/**
 * Adds default values to an imported lot and its line items
 *
 * @param lot The imported lot
 * @param sno The sequence number for the lot
 * @returns The lot with all required defaults
 */
export const addDefaultsToImportedLot = (
  lot: Lot | undefined,
  sno: number,
): Lot => {
  if (!lot) {
    throw new Error('Cannot add defaults to undefined lot');
  }

  const defaultLotName = <Trans i18nKey="common:bid_request.new_lot_name_number" values={{ sno }}/>;
  const lotId = lot.id ?? `new-${uuid()}`;
  const name = lot.name || defaultLotName;
  const cchs = updateNewUUIDs(lot.custom_column_headers || []);
  const headerIndexToId: Record<number, string> = {};
  cchs.forEach(cch => {
    headerIndexToId[cch.column_order_index] = String(cch.id);
  });

  // Process line items with sequential SNOs and defaults
  let liSno = 0;
  const lineItems = lot.line_items
    ? lot.line_items.map(li => {
      liSno += 1;
      return addDefaultsToLineItem(headerIndexToId, li, liSno, lotId);
    })
    : [];

  return {
    ...lot,
    custom_column_headers: cchs,
    id: lotId,
    line_items: lineItems,
    name: name as string, // We know this will be a string from next/translate.
    sno,
  };
};
